import React, { useEffect } from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import About from "@/components/About";
import TrustStats from "@/components/TrustStats";
import Testimonials from "@/components/Testimonials";
import ServiceArea from "@/components/ServiceArea";

export default function AboutPage() {
    useEffect(() => {
        window.scrollTo(0, 0);
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("in");
                        obs.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12 }
        );
        document.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
        return () => obs.disconnect();
    }, []);

    return (
        <main data-testid="about-page" className="relative bg-[var(--paper)]">
            <Nav />
            <header className="pt-32 md:pt-40 pb-12 md:pb-16 border-b border-line">
                <div className="maxw section-pad">
                    <div className="eyebrow mb-5">About FreshEdge</div>
                    <h1 className="font-display font-light text-5xl sm:text-6xl md:text-7xl leading-[0.98] tracking-tight max-w-4xl">
                        A small, local crew that takes the{" "}
                        <span className="italic text-[var(--terra)]">
                            detail
                        </span>{" "}
                        seriously.
                    </h1>
                </div>
            </header>
            <About />
            <TrustStats />
            <Testimonials />
            <ServiceArea />
            <Footer />
        </main>
    );
}
